module.exports = __webpack_public_path__ + "b4f2459ea74cb424c3a6f0548166a876.woff2";